module.exports = "<div\n    *ngIf=\"message\"\n    (click)=\"clear()\"\n    [ngClass]=\"{    'alert': message,\n                    'alert-success': message.type === 'success',\n                    'alert-danger': message.type === 'error' }\">\n                    {{message.text}}\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/alert/alert.component.html
// module id = ../../../../../src/app/alert/alert.component.html
// module chunks = main